import { useEffect } from 'react'

import { useGlobalConfigContext } from '../../global-config/context/globalConfigContext'
import {
  RECOMMENDATION_WIDGET_CART_BOTTOM,
  RECOMMENDATION_WIDGET_CART_MIDDLE,
  type RecommendationWidgetType,
} from '../../recommendation/config/RecommendationAreaType'
import { TENANT } from '../../tenant/tenantTypes'
import { useExperimentsContext } from '../components/ExperimentsContext'
import { EXPERIMENT_NAME_CART_RECOMMENDATION_WIDGET_ORDER } from '../model/EXPERIMENT_NAME'

export const useCartRecommendationWidgetOrderActivation = ({
  intersected,
  widgetType,
}: {
  intersected: boolean
  widgetType: RecommendationWidgetType
}): void => {
  const { tenant } = useGlobalConfigContext()
  const { addExperimentKeysForActivation } = useExperimentsContext()
  const isEligible =
    tenant === TENANT.AT &&
    (widgetType === RECOMMENDATION_WIDGET_CART_MIDDLE ||
      widgetType === RECOMMENDATION_WIDGET_CART_BOTTOM)

  useEffect(() => {
    if (!intersected || !isEligible) {
      return
    }

    addExperimentKeysForActivation(
      EXPERIMENT_NAME_CART_RECOMMENDATION_WIDGET_ORDER,
    )
  }, [addExperimentKeysForActivation, intersected, isEligible])
}
